export default "__VITE_ASSET__bd2a605a__"